import api from "@/utils/api";

export default {
  namespaced: true,
  state: {
    appModules: (() => {
      try {
        return JSON.parse(localStorage.getItem("appModules")) || [];
      } catch (e) {
        return [];
      }
    })(),
    isLoading: false,
  },
  getters: {
    appModules: (state) => state.appModules,
    isLoading: (state) => state.isLoading,
  },
  mutations: {
    setAppModules(state, modules) {
      state.appModules = modules;
      localStorage.setItem("appModules", JSON.stringify(modules));
    },
    setLoading(state, status) {
      state.isLoading = status;
    },
  },
  actions: {
    async fetchModules({ commit }) {
      commit("setLoading", true);
      try {
        const response = await api.get("/master/modules");
        commit("setAppModules", response.data.data || []);
      } catch (error) {
        console.error("Failed to fetch modules", error);
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
